import type { DetailPageConfig } from "@/components/shared/UniversalDetailPage/types/detailPage";
import type { App_Users } from "@/src/gql/graphql";
import { universalAskMeridianAction } from "@/lib/actions/definitions/universal-actions";

// Employee detail page config mirrors current tabs in /employees/[id]
export const EMPLOYEE_DETAIL_CONFIG: DetailPageConfig<App_Users> = {
  entity: "employees",
  displayName: "Employee",

  tabs: [
    {
      id: "overview",
      label: "Overview",
      icon: "user",
      variant: "blue",
      content: { type: "custom", customComponent: "EmployeeOverview" },
    },
    {
      id: "time",
      label: "Time",
      icon: "clock",
      variant: "purple",
      content: { type: "custom", customComponent: "EmployeeTimeEntries" },
    },
    {
      id: "tickets",
      label: "Tickets",
      icon: "ticket",
      variant: "orange",
      content: { type: "custom", customComponent: "EmployeeTickets" },
    },
    {
      id: "tasks",
      label: "Tasks",
      icon: "check",
      variant: "green",
      content: { type: "custom", customComponent: "EmployeeTasks" },
    },
    {
      id: "meetings",
      label: "Meetings",
      icon: "calendar",
      variant: "blue",
      content: { type: "custom", customComponent: "EmployeeMeetings" },
    },
    {
      id: "emails",
      label: "Emails",
      icon: "mail",
      variant: "purple",
      content: { type: "custom", customComponent: "EmployeeEmails" },
    },
    {
      id: "communications",
      label: "Communications",
      icon: "message-square",
      variant: "green",
      content: { type: "custom", customComponent: "EmployeeCommunications" },
    },
    {
      id: "contracts",
      label: "Contracts",
      icon: "file-text",
      variant: "orange",
      content: { type: "custom", customComponent: "EmployeeContracts" },
    },
  ],

  // Action configurations
  actions: [
    // AI ASSISTANT ACTIONS — focused Meridian chat about this employee
    universalAskMeridianAction<App_Users>(),
    {
      id: "edit",
      label: "Edit",
      icon: "edit",
      variant: "default",
      action: "openEditModal",
      primary: true,
    },
    {
      id: "view-details",
      label: "View Details",
      icon: "eye",
      variant: "outline",
      primary: true,
      action: "viewEmployee",
    },
    {
      id: "toggle-active",
      label: "Toggle Active",
      icon: "user-check",
      variant: "outline",
      action: "toggleActive",
      bulkable: true,
    },
    {
      id: "log-activity",
      label: "Log Activity",
      icon: "activity",
      variant: "outline",
      action: "logActivity",
    },
    {
      id: "delete",
      label: "Delete",
      icon: "trash",
      variant: "destructive",
      action: "deleteItem",
      bulkable: true,
    },
  ],

  breadcrumbs: {
    show: true,
    items: [
      { label: "Employees", href: "/employees" },
      {
        label: "Employee Details",
        href: (employee: App_Users) => `/employees/${employee.id}`,
        current: true,
      },
    ],
  },

  showHeader: true,
  showBreadcrumbs: true,
  showActions: true,
  defaultTab: "overview",
};
